import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { initialOnboardingState, OnboardingState } from '../onboarding-state.initial-state';

export const resetOnboardingStateReducer: CaseReducer<OnboardingState, PayloadAction<undefined>> = () => {
  return initialOnboardingState;
};
